import React from "react";

import styles from "./EducationGoal.module.scss";

export interface IEducationGoalProps {
  content: string;
}

export const EducationGoal: React.FC<IEducationGoalProps> = ({ content }) => {
  return (
    <div className={styles.container}>
      <div className={styles.title}>本校で目指したい生徒の姿</div>
      <div className={styles.content}>{content}</div>
    </div>
  );
};
export default EducationGoal;
